import gql from 'graphql-tag'
import { BMDialogFloor, AddFloorSpecificBusinessHourInput } from '@api'
import { BMDialogFloorFragment } from '@api/fragments'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addFloorSpecificBusinessHour: { floors: BMDialogFloor[] }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogFloor[]>({
  handler: (data) => data.addFloorSpecificBusinessHour.floors,
  name: 'Dialog Floor',
})

export default function addFloorsSpecificBusinessHour(
  input: AddFloorSpecificBusinessHourInput
): Promise<BMDialogFloor[]> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation AddFloorSpecificBusinessHour($input: AddFloorSpecificBusinessHourInput!) {
    addFloorSpecificBusinessHour(input: $input) {
      floors {
        ...BMDialogFloorFragment
      }
    }
  }
  ${BMDialogFloorFragment}
`
